
<mat-menu #menu>
    
    <button class="border-gray-bottom"  
            mat-menu-item 
            *ngFor="let language of supportedLanguages;let idx = index" 
            (click)="selectLanguage(language)"
            [ngClass]="{'border-gray-top':!idx}"
    >
        <div class="flex-row gap-standard min-height-none padding-small " >
            <mat-icon class="margin-none" [svgIcon]="'flag-' + language.key"></mat-icon>
            <span class="primary-text-700-darkened" >{{language.display | translate}}</span>
        </div>
    </button>

</mat-menu>

<button *ngIf="expandedSubject |async;else onlyIcon" 
        mat-raised-button 
        color="primary"
        [matMenuTriggerFor]="menu" 
        class="full-width"
>
        <mat-icon [svgIcon]="'flag-'+(selectedLanguageSubject | async)"></mat-icon>
        <span class="primary-contrast-text">
            {{(selectedItemObs | async).display | translate}}            
        </span>
        
</button>

<ng-template #onlyIcon>

    <button 
        mat-icon-button 
        [matMenuTriggerFor]="menu" 
        class="full-width"
        [matTooltip]="(selectedItemObs | async).display | translate"
        matTooltipPosition="right"
        [ngStyle]="{
            width:widthObs | async
        }"
    >
    <mat-icon [svgIcon]="'flag-'+(selectedLanguageSubject | async)"></mat-icon>
    </button>


</ng-template>

